// @flow
import React, { Component } from 'react';
import {
  CustomCsvImg,
  CustomCsvP,
  CustomTransactionFilterDiv
} from './CsvFilterStyles';
import downloadFileImg from '../../assets/images/download-file.png';
import { DefaultIcon } from '../Icon';

type Props = {
  rightEnd?: boolean,
  filterRow?: boolean,
  handleCsvFilter: () => void,
  disabled?: boolean,
  className?: string,
  center?: boolean
};

export default class CsvFilter extends Component<Props> {
  render() {
    return (
      <CustomTransactionFilterDiv
        className={this.props.className}
        filterRow={this.props.filterRow}
        rightEnd={this.props.rightEnd}
        disabled={this.props.disabled}
        center={this.props.center}
      >
        {this.props.disabled ? (
          <DefaultIcon name="downloadDoc" colorName="dustyGray" />
        ) : (
          <CustomCsvImg
            src={downloadFileImg}
            alt=""
            onClick={
              this.props.disabled ? undefined : this.props.handleCsvFilter
            }
          />
        )}

        <CustomCsvP
          color={this.props.disabled ? 'dustyGray' : 'blue'}
          onClick={this.props.disabled ? undefined : this.props.handleCsvFilter}
        >
          Download CSV
        </CustomCsvP>
      </CustomTransactionFilterDiv>
    );
  }
}
